import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

const PromoProductsSort = ({ value, onChange }) => (
  <div className="sm:flex items-center Form-select">
    <label
      className="hidden sm:block whitespace-nowrap sm:mr-4 group-with-promoDarkTheme:text-white"
      htmlFor="promo-sort-select"
    >
      Sorteaza dupa
    </label>

    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      id="promo-sort-select"
      className="promo-sort-select group-with-promoDarkTheme:bg-[#686868] group-with-promoDarkTheme:text-white group-with-promoDarkTheme:border-[#686868]"
    >
      <option value="default">Sortare implicita</option>
      <option value="price">Cel mai mic pret</option>
      <option value="discount">Cea mai mare reducere</option>
    </select>

    <style jsx global>{`
      .group.group-promoDarkTheme .promo-sort-select {
        background-image: url("${settings.websiteStatics}/images/icons/down-arrow-white.svg");
      }
    `}</style>
  </div>
);

export default PromoProductsSort;
